import LocationForm from "kinnect-front/Locations/LocationForm";
import DefaultLayout from "@/layouts/DefaultLayout";
import { Location } from "kinnect-models";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";

export default {
	name: "LocationPage",

	metaInfo() {
		const title = this.editing && this.fetched
			? `Locations - ${this.location.name}`
			: "Locations - Add a Location";

		return { title: this.fetched ? title : null };
	},

	props: { idLocation: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "locations",
		location: null,
		deleteDialogOpen: false
	} ),

	computed: {
		editing() {
			return Boolean( this.idLocation );
		},

		genDeleteDialog() {
			if ( this.editing && this.location && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete location" )}
					onConfirm={() => this.location.delete()}
					redirect={[ "back", { name: "locations" } ]}
					title="Delete Location"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the location <strong>{this.location.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Location",
					tooltip: "Delete this location"
				};
			}
		}
	},

	methods: {
		async fetchLocation() {
			if ( this.editing ) {
				this.location = await Location.findPageModel( this.idLocation );
			}
		},

		async fetch() {
			await this.fetchLocation();
		}
	},

	render() {
		return <DefaultLayout>
			<LocationForm
				location={this.location}
				loading={this.$wait.is( "find location" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
			></LocationForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
